import React, { useRef } from "react"
import {
  OverviewDataFragment,
  wpActiviteitFragment,
} from "../../__generated__/graphql-gatsby"
import BackBtn from "../backBtn"
import EventDetails from "../eventDetails"
import PageBuilder from "../pageBuilder"
import Spacer from "../pageBuilder/spacer"
import SEO from "../SEO"
import ShareBtn from "../shareBtn"

interface IProps {
  data: Maybe<wpActiviteitFragment>
  overviewData?: Maybe<Array<Maybe<OverviewDataFragment>>>
  sessionKey: string
}

const ActiviteitComponent: React.FC<IProps> = ({
  data,
  overviewData,
  sessionKey,
}) => {
  const { seo, page_builder, activiteit_fields, title, uri } = {
    ...data,
  }

  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <SEO
        title={seo?.title}
        description={seo?.metaDesc}
        ogTitle={seo?.opengraphTitle}
        ogDescription={seo?.opengraphDescription}
        img={{
          url: seo?.opengraphImage?.sourceUrl,
          alt: seo?.opengraphImage?.altText,
          width: seo?.opengraphImage?.mediaDetails?.width,
          height: seo?.opengraphImage?.mediaDetails?.height,
        }}
        siteName={seo?.opengraphSiteName}
        canonical={uri}
      />
      <ShareBtn title={String(seo?.title)} ref={ref} />
      <Spacer height={56} />
      <PageBuilder
        blocks={page_builder?.pageBuilder}
        overviewData={overviewData}
        sessionKey={sessionKey}
      />
      <BackBtn />
      <EventDetails ref={ref} data={activiteit_fields} title={title} />
    </>
  )
}

export default ActiviteitComponent
